'use strict';

module.exports = 10;
